export var SESSION_STORAGE_KEY = "oxford-favourite-vehicle";
export var handlePostAuthFavourite = function(addFavourite, isLoggedIn) {
    var oxfordFavouriteVehicle = sessionStorage.getItem(SESSION_STORAGE_KEY);
    if (isLoggedIn && oxfordFavouriteVehicle) {
        var preAuthFavouriteVehicle = JSON.parse(oxfordFavouriteVehicle);
        addFavourite(preAuthFavouriteVehicle.id);
        sessionStorage.removeItem(SESSION_STORAGE_KEY);
    }
};
